module.exports = __webpack_public_path__ + "img/farm.3e9c3d1f.png";